import { useQuery } from '@tanstack/react-query';
import queryKeys from '../keys/queryKeys';
import useMutateHook from '../../useMutateHook';
import { postLogin } from '../service/auth';

//로그인
export function useLogin() {
  return useMutateHook({
    fetchApi: ({ loginId, password }) => postLogin({ loginId, password }),
  });
}
